export default __webpack_public_path__ + "static/media/hourglass_black.d3da67a6.svg";